import { gql } from '@apollo/client';

export const GET_METRO2_DOWNLOADED_RESULT = gql`
query getMETRO2SummaryDetailsForDownload($input: GetMETRO2BatchSummaryInput) {
  getMETRO2SummaryDetailsForDownload(input: $input) {
    batchId
    batchRunStatus
    period
    batchStartTime
    ruleId
    ruleDescription
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    totalTestExecuted
    fileName
    fieldId
    fieldName
    fieldNumber
    isActive
    position
    recording
    ruleTypeSerial
  }
}`;

export const GET_BATCH_TEST_FOR_METRO2 = gql`
query getBatchTestsForMETRO2($input: GetBatchTestsForMETRO2Input ) {
  getBatchTestsForMETRO2(input: $input){
    batchId
    batchRunStatus
    period
    batchStartTime
    ruleId
    ruleDescription
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    totalTestExecuted
    fileName
    fieldId
    fieldName
    fieldNumber
    isActive
    position
    recording
    ruleTypeSerial
  }
}`;

export const GET_MONTH_FILTERED_BATCH_TESTS_FOR_METRO2 = gql`
query getMETRO2BatchTestsByMonth($input: GetMETRO2BatchTestsByMonthInput) {
  getMETRO2BatchTestsByMonth(input: $input) {
    batchId
    batchRunStatus
    period
    batchStartTime
    ruleId
    ruleDescription
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    totalTestExecuted
    fileName
    fieldId
    fieldName
    fieldNumber
    isActive
    position
    recording
    ruleTypeSerial
  }
}`;

export const GET_FAILED_TESTS_FOR_METRO2 = gql`
query getFailedTestResultsForMetro2($input: GetFailedTestResultsForMetro2Input ) {
  getFailedTestResultsForMetro2(input: $input){
    criteria {
      batchId
      ruleId
      fieldId
      fieldName
      fieldNumber
      isActive
      position
      recording
      ruleTypeSerial
      ruleDescription
    }
    testResults {
      rowId
      testDate
      errorColumns
      errorData
      errorDescription
      errorMessage
      testPass
      testFail
      testError
      testRunStatus
    }
    pagination{
      totalCount
    }
  }
}`;

export const GET_AUDIT_LOGS_FOR_METRO2 = gql`
query getAuditLogsForMetro2($input: GetAuditLogsForMetro2Input ) {
  getAuditLogsForMetro2(input: $input){
    eventId
    auditLogId
    commentId
    commentText
    user {
      firstName
      lastName
      initials
    }
    event {
      eventName
    }
    comment {
      commentText
    }
    createdAt
  }
}`;

export const GET_USER_COMMENTS_FOR_METRO2 = gql`
query getUserCommentsForMetro2($input: GetUserCommentForMetro2Input ) {
  getUserCommentsForMetro2(input: $input){
    commentId
    commentText
    userId
    batchId
    ruleId
    createdAt
    user {
      firstName
      lastName
      initials
    }
    METRO2AuditLog {
      eventId
      commentId
      auditLogId
      createdAt
    }
  }
}`;

export const GET_LATEST_BATCH_FOR_METRO2 = gql`
query getCurrentStatusOfLatestBatchForMETRO2 {
  getCurrentStatusOfLatestBatchForMETRO2 {
    batchRunStatus
    batchId
    batchEndTime
    batchStartTime
    totalRecords
    fileName
    totalTestCases
  }
}`;
